export default __webpack_public_path__ + "static/media/PaytonLovelace.797e8248.png";